import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';

import SatFollowText from '@components/common/satUI/SatFollowText';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

const IntensityModulatedRadiationTherapy = forwardRef((props, ref) => {
  const {
    parentContainer,
    complete,
    followTextError,
    setFollowTextError,
    showError,
    checkComplete,
  } = props;

  const { nextFollowText, checkMachedFollowTexts } = $hooks.useEa();

  // 선택자로 했을 시, 외부 다른 컴포넌트 선택될 수 있어 useRef() 사용
  const containerRef = useRef();
  const container = containerRef?.current;

  const [isAllMatched, setIsAllMatched] = useState(false);

  const handleCheckComplete = () => {
    if (typeof checkComplete === 'function') checkComplete();
  };

  const handleMatched = (_, followTextId) => {
    const isAllMatched = checkMachedFollowTexts(container);

    nextFollowText(parentContainer, followTextId);
    setIsAllMatched(isAllMatched);
    handleCheckComplete();

    if (isAllMatched) {
      setFollowTextError(false);
    }
  };

  useEffect(handleCheckComplete, [isAllMatched]);

  useImperativeHandle(ref, () => ({
    isValidCheck() {
      if (!isAllMatched) {
        setFollowTextError(true);
      }

      return isAllMatched;
    },
  }));

  return (
    <React.Fragment>
      <div className="txt-pad-wrap" ref={containerRef}>
        <p className="tit-small mgt-5 mgb-8">항암세기조절방사선치료 관련</p>
        1) 항암세기조절방사선치료특약은
        <SatFollowText
          followText={'항암세기조절방사선치료'}
          complete={complete}
          onMatched={handleMatched}
        />
        를
        <SatFollowText
          followText={'받은 경우'}
          complete={complete}
          onMatched={handleMatched}
        />
        보험금을
        <SatFollowText
          followText={'지급'}
          complete={complete}
          onMatched={handleMatched}
        />
        합니다.
        <br />
        2)
        <SatFollowText
          followText={'항암세기조절방사선치료'}
          complete={complete}
          onMatched={handleMatched}
        />
        란 방사선 조사 방향을 수십배까지 세분화하고, 각 세분화된 영역마다
        방사선의 양 (
        <SatFollowText
          followText={'세기'}
          complete={complete}
          onMatched={handleMatched}
        />
        )를 조절함으로써 종양 주위의 정상조직에 들어가는 방사선량을 최소화하고
        <SatFollowText
          followText={'암세포에만 선택적으로 방사선량을'}
          complete={complete}
          onMatched={handleMatched}
        />
        <SatFollowText
          followText={'조절하여 조사할 수 있는 방사선치료'}
          complete={complete}
          onMatched={handleMatched}
        />
        를 말하며,
        <SatFollowText
          followText={'방사선세기조절이'}
          complete={complete}
          onMatched={handleMatched}
        />
        <SatFollowText
          followText={'없거나 입자방사선을 이용하는 치료는 보장 대상에 제외'}
          complete={complete}
          onMatched={handleMatched}
        />
        합니다.
      </div>

      <SatValidationErrMsg
        visible={showError && followTextError[1]}
        type="error"
        message="입력하지 않은 항목이 있습니다."
      />
    </React.Fragment>
  );
});

export default IntensityModulatedRadiationTherapy;
